import { Observable } from 'rxjs';
import { invertBool } from './invert-bool';

export const hideIfFalse = (bool$: Observable<boolean>): { expressions: { hide: Observable<boolean> } } => ({
	expressions: {
		hide: bool$.pipe(invertBool()),
	},
});

export const hideIfTrue = (bool$: Observable<boolean>): { expressions: { hide: Observable<boolean> } } => ({
	expressions: {
		hide: bool$.pipe(),
	},
});
